import { useLoader } from "@react-three/fiber";
import { TextureLoader } from "three";
import { isImage } from "../Utils/Helpers";
import { DEFAULT_IMAGE } from "../Utils/Constants";

const filePath = require.context("../img", false);

export const useTexture = (uri) => {
  const input = getValidInput(uri);
  const texture = useLoader(TextureLoader, input);
  return [texture];
};

const getValidInput = (uri) => {
  if (!isImage(uri)) return filePath(DEFAULT_IMAGE);
  const isStatic = uri.split("/")[1] === "static";
  const input = !isStatic ? filePath(uri) : uri;
  return input;
};
